import { render } from "./DocsExample.vue?vue&type=template&id=21ea9911"
import script from "./DocsExample.vue?vue&type=script&lang=js"
export * from "./DocsExample.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/HCL_coreui_vue_Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__